// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/js/main": 0,
	"css/main": 0
};

// no install chunk

// no chunk on demand loading

// no prefetching

// no preloaded

// no external install chunk

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);